const products = [
  {
    name: "Pharmacy Dispensing Counter",
    badge: "Best Seller",
    desc: "Custom SS304 pharmacy counters with lockable cabinets, built-in shelving, and smooth hygienic surfaces for high-volume dispensing environments.",
    features: ["Lockable storage bays", "Integrated cable management", "Adjustable shelving", "Hygienic sealed joints"],
    image: "/images/hospital/pharmacy-counter.webp",
  },
  {
    name: "Medicine Storage Cabinets",
    badge: "Popular",
    desc: "Durable wall-mounted and free-standing stainless steel medicine cabinets for organised, hygienic drug storage in wards, theatres, and pharmacies.",
    features: ["SS304 / SS316 grade", "Glass or solid doors", "Key or digital lock", "Custom dimensions"],
    image: "/images/hospital/cabinets.webp",
  },
  {
    name: "Instrument Trolleys",
    badge: "Theatre Grade",
    desc: "Heavy-duty stainless steel instrument trolleys for operating theatres, ICUs, and treatment rooms — designed for swift sterilisation and manoeuvring.",
    features: ["360° lockable castors", "Multiple tray levels", "Autoclave compatible", "Push-bar handle"],
    image: "/images/hospital/trolleys.webp",
  },
  {
    name: "Sterile Store Shelving",
    badge: "Infection Control",
    desc: "Open-frame or enclosed stainless steel shelving systems engineered for clean-room and sterile store environments in hospitals and health centres.",
    features: ["Open or enclosed options", "Easy-to-clean surfaces", "Load-rated shelves", "Modular configuration"],
    image: "/images/hospital/sterile-shelving.webp",
  },
  {
    name: "Nurse Station Counter",
    badge: "Custom Fit",
    desc: "Ergonomically designed nurse station counters with integrated sinks, storage, and workstations — fabricated to your ward floor plan.",
    features: ["Integrated sink option", "Built-in waste chutes", "Cable routing channels", "Anti-microbial finish"],
    image: "/images/hospital/nurse-station.webp",
  },
  {
    name: "Mortuary & Lab Equipment",
    badge: "Specialist",
    desc: "Mortuary tables, pathology benches, autopsy equipment, and laboratory counters fabricated to international standards for clinical accuracy and hygiene.",
    features: ["Sloped drainage surface", "Fully welded joints", "SS316 grade steel", "Custom lab bench layouts"],
    image: "/images/hospital/mortuary-lab.webp",
  },
];

export default function HospitalProducts() {
  return (
    <section id="products" className="py-24 bg-gray-50">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-6 mb-14">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-teal-600 text-xs font-bold uppercase tracking-widest">Product Range</span>
          <h2 className="text-gray-900 text-3xl md:text-4xl font-extrabold mt-3 uppercase tracking-tight">
            Medical Equipment We Fabricate
          </h2>
          <p className="text-gray-500 text-sm mt-4 leading-relaxed">
            Every product is custom-built in our Nairobi workshop using premium-grade stainless steel,
            then delivered and installed by our experienced healthcare fit-out team.
          </p>
        </div>
      </div>

      {/* Products Grid */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <div
              key={product.name}
              className="bg-white rounded-lg border border-gray-100 hover:border-teal-200 transition-all duration-300 overflow-hidden group"
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 bg-teal-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
                  {product.badge}
                </span>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-gray-900 font-bold text-sm uppercase tracking-wide mb-2">
                  {product.name}
                </h3>
                <p className="text-gray-500 text-xs leading-relaxed mb-4">{product.desc}</p>

                {/* Features */}
                <ul className="space-y-1 mb-5">
                  {product.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-xs text-gray-600">
                      <i className="ri-check-line text-teal-600 flex-shrink-0"></i>
                      {f}
                    </li>
                  ))}
                </ul>

                <a
                  href="#inquiry"
                  onClick={(e) => { e.preventDefault(); document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" }); }}
                  className="inline-flex items-center gap-1 text-teal-600 font-semibold text-xs hover:gap-2 transition-all cursor-pointer"
                >
                  Enquire Now <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
